export const az = {
  title: 'Ağac örtüyü',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Funksiya',
      value: 'Ağac örtüyünün sahələrini müəyyən edir',
    },
    {
      label: 'Qətmə',
      value: '30 × 30 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal torpaq (Antarktida və Arktika adaları istisna)',
    },
    {
      label: 'Mənbə',
      value:
        'Hüseyn, M. C., P. V. Potapov, R. Mur, M. Xançer, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice və C. R. G. Townshend. 2013. "XXI əsr meşə örtüyünün dəyişməsinin yüksək reqliktli qlobal xəritələri". Bakı: Elm, 2005,155 səh. Verilənlər: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Tezlik',
      value: '',
    },
    {
      label: 'Məzmun tarixi',
      value: '2000 & 2010',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        'Bu tədqiqatın məqsədi ilə "ağac örtüyü" hündürlüyü 5 metrdən hündür olan bütün bitki örtüyü kimi müəyyən edilmişdir. "Ağac örtüyü" ağacların biofiziki mövcudluğudur və müxtəlif kanop sıxlığı üzərində mövcud olan təbii meşələr və ya plantasiyalar formasını ala bilər.',
    },
    {
      label: 'Lisenziya',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Maryland Universiteti, Google, USGS və NASA-nın GLAD (Global Land Analysis & Discovery) laboratoriyası arasında əməkdaşlıq edən bu məlumat dəsti 2000 və 2010-ci illər üçün 30 × 30 metrlik qətnamə ilə bütün qlobal torpaqlar üzərində (Antarktida və bir sıra Arktik adaları istisna olmaqla) ağac örtüyü nümayiş etdirir. "Faizli ağac örtüyü" torpaq səthinin ağac kanop örtüyünün sıxlığı kimi müəyyən edilir və sıxlıq mötərizəsi ilə rəng kodludur (bax: əfsanə).\n\nBu qatdakı verilənlər Landsat 7 tematik mapper plus (ETM+) sensorundan çoxspektrli peyk şəkilləri vasitəsilə əmələ gətirilmişdir. 600 000-dən çox şəklin aydın səthi müşahidələri nəzarətli öyrənmə alqoritmi vasitəsilə hər piksel ağac örtüyünü müəyyən etmək üçün Yer kürəsinin müşahidəsi və məlumat analizi üçün bulud platforması olan Google Earth Engine-dən istifadə edərək təhlil edilmişdir.\n\nGöstərilən verilənlərin ağac örtüyü kanopinin sıxlığı seçimə görə dəyişir - xəritədəki əfsanədən istifadə edərək minimal ağac örtüyü kanopu sıxlıq həddini dəyişin.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
